const dataRoomers = (state = {}, action) => {
  switch (action.type) {
    default: return state;
  }
};

export default dataRoomers;
